import { Locale } from '@libs/core';
import type { GtmConfigurationDictionary } from '../types';

export const gtmConfigurationDictionary: GtmConfigurationDictionary = {
    [Locale['en-CA']]: {
        gtmContainerId: process.env.NEXT_PUBLIC_GTM_CA_CONTAINER_ID as string,
        gtmPreview: process.env.NEXT_PUBLIC_GTM_CA_PREVIEW as string,
        gtmAuth: process.env.NEXT_PUBLIC_GTM_CA_AUTH as string,
    },
    [Locale['en-US']]: {
        gtmContainerId: process.env.NEXT_PUBLIC_GTM_US_CONTAINER_ID as string,
        gtmPreview: process.env.NEXT_PUBLIC_GTM_US_PREVIEW as string,
        gtmAuth: process.env.NEXT_PUBLIC_GTM_US_AUTH as string,
    },
};

export enum Events {
    VIEW_PAGE_SECTION = 'view_page_section',
    VIEW_ITEM_LIST = 'view_item_list',
}

export enum LoginEvents {
    CHECKOUT = 'Checkout',
    LOGIN_PAGE = 'Login Page',
    SIGN_IN_DRAWER = 'Login Pop-Up Window',
}
